import script from "./AppKintzCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./AppKintzCarousel.vue?vue&type=script&setup=true&lang=js"

import "./AppKintzCarousel.vue?vue&type=style&index=0&id=bbf4b050&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbf4b050"]])

export default __exports__